import React from 'react';
import PropTypes from 'prop-types';
import { Field as FormField } from 'redux-form';
import styled from 'styled-components';
import { Theme, colors } from '../../legacy/hui/src/styled/theme';
import ReactTooltip from 'react-tooltip';
import Autocomplete from 'react-google-autocomplete';
import { getPostcodeSuburbFromGoogleAddress } from '../utils/maps';

/*copied from hui component todo fix */
const StyledField = styled(FormField)`
  width: 100%;
  font-size: 16px;
  border: 0;
  border-radius: 4px;
  appearance: none;
  outline: 0;
  border: 1px solid ${colors.GREY};
  position: relative;
  padding: 11px 20px;
`;

export const StyledLabel = styled.label`
  font-size: 13px;
  position: absolute;
  left: 5px;
  top: -6px;
  padding: 0 5px;
  background-color: ${Theme.snow};
`;

const FieldInfoLabel = styled.span`
  float: right;
  font-size: 13px;
  color: ${Theme.muted};
  margin: 3px 0;
  cursor: pointer;
`;

const FieldWrapper = styled.div`
  position: relative;
  margin-bottom: 25px;
`;

export const ErrorText = styled.div`
  color: #ca3121;
  padding: 10px 0;
  font-size: 14px;
`;

const renderField = ({ input, meta, setSuburb, relatedFieldName, ...rest }) => {
  return (
    <div className="input-row">
      <Autocomplete
        onPlaceSelected={place => {
          input.onChange(place.formatted_address);
          const suburb = getPostcodeSuburbFromGoogleAddress(place);
          if (suburb) {
            setSuburb(relatedFieldName, suburb);
          }
        }}
        types={['geocode']}
        componentRestrictions={{ country: 'au' }}
        {...input}
        {...rest}
        value={input.value.formatted_address ? input.value.formatted_address : input.value}
      />
      {meta.error && meta.touched && <ErrorText className="error">{meta.error}</ErrorText>}
    </div>
  );
};

renderField.propTypes = {
  input: PropTypes.object,
  meta: PropTypes.object,
  setSuburb: PropTypes.func,
  relatedFieldName: PropTypes.string
};

const CustomAddress = ({
  label,
  name,
  component = renderField,
  placeholder = '',
  fieldInfoLabel,
  fieldInfoValue,
  type,
  children,
  className,
  relatedFieldName,
  setSuburb,
  ...rest
}) => {
  return (
    <FieldWrapper>
      <StyledField
        name={name}
        setSuburb={setSuburb}
        relatedFieldName={relatedFieldName}
        component={component}
        placeholder={placeholder}
        type={type}
        className={className}
        {...rest}
      >
        {children}
      </StyledField>
      <StyledLabel type={type} component={component}>
        {' '}
        {label}
      </StyledLabel>

      {fieldInfoLabel && (
        <FieldInfoLabel data-tip={fieldInfoValue}>
          {fieldInfoLabel}
          <ReactTooltip multiline />
        </FieldInfoLabel>
      )}
    </FieldWrapper>
  );
};

CustomAddress.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  component: PropTypes.node,
  placeholder: PropTypes.string,
  fieldInfoLabel: PropTypes.string,
  fieldInfoValue: PropTypes.string,
  type: PropTypes.string,
  setSuburb: PropTypes.func,
  relatedFieldName: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string
};

export default CustomAddress;
